/* eslint-disable @typescript-eslint/no-explicit-any */
// NOTE: angular `ErrorHandler` uses `any` in it's public api, therefore we're following the same pattern here

export abstract class ErrorNotifierService {
  abstract handleError(error: any): void;
}
